import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { IMAGES } from "../../data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TIPOS = [
  { value: "club", label: "Iscrizione Club Storiche" },
  { value: "corsi", label: "Corsi Piloti / Navigatori" },
  { value: "village", label: "Legend Village" },
  { value: "info", label: "Informazioni generali" },
];

export const inputCls =
  "w-full bg-neutral-900 border border-neutral-800 p-3 text-sm text-white focus:border-red-600 focus:outline-none";
export const labelCls = "block mono-label text-xs uppercase text-neutral-300 mb-1";

export const ContactForm = () => {
  const [form, setForm] = useState({ nome: "", email: "", tipo: "info", richiesta: "" });
  const [sending, setSending] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Richiesta inviata a info@legendteam.it. Ti risponderemo via email.");
      setForm({ nome: "", email: "", tipo: "info", richiesta: "" });
    } catch (err) {
      toast.error("Invio non riuscito. Riprova tra poco.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form
      data-testid="contact-form"
      onSubmit={onSubmit}
      className="space-y-4 bg-neutral-950 p-8 border border-neutral-800 h-full flex flex-col"
    >
      <div>
        <div className="mono-label text-xs text-red-500 uppercase tracking-wider mb-1">01 &bull; Richiesta informazioni</div>
        <h3 className="font-display text-2xl font-black uppercase text-white">Scrivi alla Scuderia</h3>
        <p className="text-xs text-neutral-400 mt-1">
          Club storiche, corsi, Village o informazioni generali: la richiesta arriva a info@legendteam.it.
        </p>
      </div>
      <div>
        <label htmlFor="nome" className={labelCls}>Nominativo Completo</label>
        <input id="nome" name="nome" type="text" data-testid="contact-name-input" className={inputCls} value={form.nome} onChange={onChange} required minLength={2} />
      </div>
      <div>
        <label htmlFor="email" className={labelCls}>Indirizzo Email</label>
        <input id="email" name="email" type="email" data-testid="contact-email-input" className={inputCls} value={form.email} onChange={onChange} required />
      </div>
      <div>
        <label htmlFor="tipo" className={labelCls}>Tipo di Richiesta</label>
        <select id="tipo" name="tipo" data-testid="contact-type-select" className={inputCls} value={form.tipo} onChange={onChange}>
          {TIPOS.map((t) => (
            <option key={t.value} value={t.value}>{t.label}</option>
          ))}
        </select>
      </div>
      <div>
        <label htmlFor="richiesta" className={labelCls}>Richiesta Specifica</label>
        <textarea id="richiesta" name="richiesta" rows="5" data-testid="contact-message-textarea" className={inputCls} value={form.richiesta} onChange={onChange} required minLength={5} />
      </div>
      <div data-testid="contact-photo" className="relative flex-1 min-h-[180px] border border-neutral-800 overflow-hidden">
        <img
          src={IMAGES.contactPhoto}
          alt="BMW Legend Team in gara tra le balle di paglia con gli sponsor MCG e Le Fonti"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <span className="absolute left-3 bottom-3 mono-label text-[10px] uppercase tracking-wider bg-neutral-950/85 text-neutral-300 px-2 py-1">
          Legend Team &bull; in gara con i nostri partner
        </span>
      </div>
      <div className="pt-2 flex flex-col sm:flex-row justify-between items-center gap-4">
        <span className="mono-label text-xs text-neutral-400">Risposta diretta via email dalla segreteria</span>
        <button
          type="submit"
          data-testid="contact-submit-button"
          disabled={sending}
          className="w-full sm:w-auto px-8 py-3 bg-red-600 hover:bg-red-500 disabled:opacity-50 text-white font-black uppercase text-xs tracking-widest transition-colors"
        >
          {sending ? "Invio in corso..." : "Invia Messaggio"}
        </button>
      </div>
    </form>
  );
};
